import { useSignal } from "@preact/signals-react"

export default function useCellPopover(noResult) {
	const isOpenPopover = useSignal(null)

	const onClosePopover = () => isOpenPopover.value = null

	const onOpenPopover = target => {
		if (!noResult) isOpenPopover.value = target
	}


	return {
		isOpenPopover: isOpenPopover.value,
		onOpenPopover,
		onClosePopover,
	}
}